module.exports = __webpack_public_path__ + "static/media/classroom_view_quick_view_video.27d650bb.mov";